import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { isAdmin } from "@/lib/admin";
import { QuoteCurationDialog } from "./QuoteCurationDialog";

/** Admin-only entry point. Renders nothing for everyone else; the API enforces auth independently. */
export function CurateQuoteButton({ quoteId, className, label = "Curate", onRemoved }: {
  quoteId: number; className?: string; label?: string; onRemoved?: (id: number) => void;
}) {
  const { currentUser } = useAuth();
  const [open, setOpen] = useState(false);
  if (!isAdmin(currentUser?.uid)) return null;
  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        onKeyDown={(e) => e.stopPropagation()}
        className={className ?? "rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-sm font-medium text-amber-800 transition hover:bg-amber-100 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-300 focus-visible:ring-offset-1"}
        data-testid={`btn-curate-${quoteId}`}
        title="Open curator desk"
      >
        {label}
      </button>
      {open && <QuoteCurationDialog quoteId={quoteId} open={open} onOpenChange={setOpen} onRemoved={onRemoved} />}
    </>
  );
}
